module.exports = __webpack_public_path__ + "static/media/program1.a046fac3.png";